export default __webpack_public_path__ + "static/media/close-12px-pink.2f06b144.svg";